export const NAME_SUGGESTIONS = [
  'Goal Diggers',
  'Sunday Lads',
  'Family Cup',
  'Office Bracket',
] as const;

export const CREATE_WORLD_CUP_GROUP_COPY = {
  STEP_1_TITLE: 'Name your squad.',
  STEP_1_SUBTITLE: 'Give your group a name and an optional description.',
  STEP_2_TITLE: 'Set the stakes.',
  STEP_2_SUBTITLE: 'Buy-in + how winners split the pot.',
  NAME_LABEL: 'Squad name',
  NAME_PLACEHOLDER: 'e.g. Office Bracket',
  PRIZES_LABEL: 'Define your stakes',
  PRIZES_PLACEHOLDER:
    'Describe the prizes (optional): e.g. Winner gets a jersey! What do winners get? (You handle payouts outside the app.)',
  COINS_LABEL: 'Coin entry fee',
  COINS_HINT: 'Max follows your balance (server capped). 0 = free to join.',
  PAYOUT_LABEL: 'Pot split',
  PAYOUT_WINNER_TAKE_ALL: 'Winner takes all',
  PAYOUT_WINNER_TAKE_ALL_DESC: '1st place wins the entire pot',
  PAYOUT_TOP_THREE: 'Top 3 — split pot',
  PAYOUT_TOP_THREE_DESC: 'Reward the podium finish',
  PCT_FIRST: '1st',
  PCT_SECOND: '2nd',
  PCT_THIRD: '3rd',
  PCT_SUM_ERROR: 'Percentages for 1st, 2nd, and 3rd must add up to 100.',
  BACK: 'Back',
  ERROR_ALERT_TITLE: 'Could not create squad',
  NEXT_STEP: 'Continue',
  NEXT_STEP_SUBLABEL: 'Stakes →',
  CREATE: 'Create squad',
  CREATE_SUBLABEL: undefined,
  CREATING: 'Creating…',
  SECTION_COLOUR: '01 — COLOUR',
  SECTION_EMBLEM: '02 — EMBLEM',
  SECTION_NAME: '01 — SQUAD NAME',
  SECTION_TAGLINE: '02 — DESCRIPTION · OPTIONAL',
  SECTION_POT_SPLIT: 'POT SPLIT',
  SECTION_BUY_IN: 'BUY-IN PER PLAYER',
  FREE_LABEL: 'Free',
} as const;

export const CREATE_WORLD_CUP_GROUP_DEFAULT_PAYOUT = {
  FIRST: 50,
  SECOND: 30,
  THIRD: 20,
} as const;

export const CREATE_WORLD_CUP_GROUP_STEPS = {
  TOTAL: 3,
} as const;

export const CREATE_WORLD_CUP_GROUP_STAKES_TEXTAREA_HEIGHT = 90;

export const CREST_COLORS = [
  { id: 'purple', from: '#9B7BFF', to: '#5B2FCC' },
  { id: 'yellow', from: '#FFCB47', to: '#C49A1F' },
  { id: 'green', from: '#4ADE9B', to: '#1A8A4D' },
  { id: 'coral', from: '#FF8A65', to: '#D84315' },
  { id: 'blue', from: '#5BB8FF', to: '#1565C0' },
  { id: 'pink', from: '#F472B6', to: '#9D174D' },
] as const;

export type CrestColorId = (typeof CREST_COLORS)[number]['id'];

export const CREST_EMBLEM_IDS = [
  'trophy',
  'star',
  'flame',
  'lightning',
  'shield',
  'crown',
] as const;

export type CrestEmblemId = (typeof CREST_EMBLEM_IDS)[number];

export const COIN_SLIDER_STEPS = [0, 50, 100, 250, 500, 1000] as const;
